import React from "react";
import { connect } from "react-redux";
import { array, string, object } from "prop-types";
import get from "lodash/get";
import { Link } from "@quintype/components";

import SocialShareIcons from "../../social-icons";

import "./footer.m.css";

const renderFooter = footerMenuLinks =>
  footerMenuLinks.map(
    (item, index) =>
      item.isExternalLink ? (
        <li styleName="list-item" key={index}>
          <a href={item.completeUrl}>{item.title}</a>
        </li>
      ) : (
        <li styleName="list-item" key={index}>
          <Link href={item.completeUrl || "/"}>{item.title}</Link>
        </li>
      )
  );

const FooterBase = ({ footerMenuLinks, copyrightText, socialLinks }) => (
  <div styleName="wrapper">
    <ul styleName="menu-group">{renderFooter(footerMenuLinks)}</ul>
    <div styleName="copyright-social">
      <p styleName="copyright-text">
        {copyrightText}{" "}
        <a href="https://www.quintype.com" target="_blank" rel="noopener noreferrer">
          | Powered by Quintype{" "}
        </a>
      </p>
      {socialLinks && (
        <div styleName="follow-us">
          <span styleName="follow-us-text">Follow us on</span>
          <SocialShareIcons />
        </div>
      )}
    </div>
  </div>
);

const mapStateToProps = state => {
  return {
    copyrightText: get(state, ["qt", "config", "publisher-settings", "copyright"], ""),
    footerMenuLinks: get(state, ["qt", "data", "navigationMenu", "footerMenuLinks"], []),
    socialLinks: get(state, ["qt", "config", "social-links"], [])
  };
};

FooterBase.propTypes = {
  copyrightText: string,
  footerMenuLinks: array,
  socialLinks: object
};

const FooterRow = connect(mapStateToProps)(FooterBase);

export default FooterRow;
